<template>
  <div class="RegisterCardStyle">
    <SuccessBase :title="$t('user.user_email-has-been-sent-to-check')">
      <template #default>
        {{ $t('user.user_check-inbox') }}
      </template>
    </SuccessBase>
  </div>
</template>
<script>
import { SuccessBase } from '@/components/layouts'

export default {
  components: {
    SuccessBase
  },
  data: () => {
    return {
      //
    }
  },
  methods: {}
}
</script>
